/**
 * Údarás na Gaeltachta Brand Configuration
 * 
 * Brand-specific settings for the HubChat Admin application
 * when running under the Údarás na Gaeltachta brand.
 */

export const udarasBrandConfig = {
  // Application branding
  appName: 'HubChat Admin',
  appTitle: 'HubChat Admin - Údarás na Gaeltachta',
  appDescription: 'Administrative dashboard for Údarás na Gaeltachta knowledge management',
  
  // Header configuration
  header: {
    showLogo: true,
    logoVariant: 'full' as const,
    showAppName: true,
    showUserProfile: true,
    navigationStyle: 'government' as const, // 'government' | 'modern' | 'minimal'
  },
  
  // Color scheme
  colors: {
    primary: '#0085CA',
    secondary: '#84BD00',
    accent: '#E30000',
    header: {
      background: 'var(--header-bg)',
      text: 'var(--header-text)',
      brandBackground: 'var(--header-brand-bg)',
      brandText: 'var(--header-brand-text)',
    }
  },
  
  // Design system
  design: {
    borderRadius: 'sharp', // 'sharp' | 'rounded' | 'mixed'
    borderStyle: 'angular', // 'angular' | 'soft' | 'mixed'
    shadowStyle: 'subtle', // 'subtle' | 'prominent' | 'minimal'
    typography: 'government', // 'government' | 'modern' | 'classic'
  },
  
  // Layout preferences
  layout: {
    headerHeight: '64px',
    sidebarWidth: '240px',
    contentPadding: 'var(--space-6)',
    cardSpacing: 'var(--space-4)',
  },
  
  // Feature flags
  features: {
    enableAdvancedAnalytics: true,
    enableMultiLanguage: true,
    enableGovernmentCompliance: true,
    enableAuditLogging: true,
  },
  
  // Government-specific settings
  government: {
    complianceMode: true,
    auditRequired: true,
    dataRetention: '7years',
    accessibilityLevel: 'WCAG-AA',
  }
} as const;

export type UdarasBrandConfig = typeof udarasBrandConfig;
